import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {BundleProduct} from "../services/bundle-product";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ShipmentDriversService} from "../services/shipment-drivers.service";
import {ShipmentDriver} from "../services/shipment-driver";
import {BranchesService} from "../services/branches.service";
import {ShipmentRoutesService} from "../services/shipment-routes.service";
import {ShipmentRoute} from "../services/shipment-route";

@Component({
    selector: 'app-shipment-route-detail',
    templateUrl: './shipment-route-detail.component.html',
    styleUrls: ['./shipment-route-detail.component.scss'],
    providers: [ShipmentDriversService, BranchesService, ShipmentRoutesService]
})

export class ShipmentrouteDetailComponent implements OnInit {

    shipmentrouteId: string;
    bundle: ShipmentRoute;
    shipmentDrivers: ShipmentDriver[];

    requirementProducts: BundleProduct[];
    rewardProducts: BundleProduct[];

    constructor(public activatedRoute: ActivatedRoute,
                public shipmentDriversService: ShipmentDriversService,
                public shipmentroutesService: ShipmentRoutesService,
                public branchesService: BranchesService,
                public ngbModal: NgbModal,
                private router: Router) {
        this.shipmentrouteId = activatedRoute.snapshot.params.shipmentRouteId;
    }

    branches;

    ngOnInit() {
        this.branches = this.branchesService.branchesDetails;
        this.shipmentDriversService.getShipmentDrivers().then(shipmentDrivers => {
            this.shipmentDrivers = shipmentDrivers;

            if (this.shipmentrouteId !== 'new') {
                this.shipmentroutesService.getShipmentRoute(this.shipmentrouteId).then(bundle => {
                    this.setProductsAndBundle(bundle);
                });
            } else {
                this.bundle = ShipmentRoute.fromJSON({});
            }
        });
    }

    save() {
        if (this.shipmentrouteId === 'new') {
            this.shipmentroutesService.addShipmentRoute(this.bundle).then((shipmentRoute) => {
                this.router.navigateByUrl('/shipment-routes/' + shipmentRoute.id);
            }, (error) => {
                alert('kunne ikke gemmes, udfyldt alle felter');
            });
        } else {
            this.shipmentroutesService.updateShipmentRoute(this.bundle).then(bundle => {
                this.setProductsAndBundle(bundle);
            })
        }
    }

    setProductsAndBundle(bundle: ShipmentRoute) {
        this.bundle = bundle;
    }

    branchChanged() {

    }
}
